var _rect, _rect2, _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossOutToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 29,
    rx: 4.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 30,
    height: 29,
    rx: 4.5,
    stroke: "#272727"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.82102 18H7.69602L9.74432 12.1818L11.0455 12.1818L13.0966 18H11.9716L10.4176 13.375H10.3722L8.82102 18ZM8.85795 15.7188L11.9261 15.7187V16.5653H8.85795V15.7188ZM12.9029 18L12.9029 12.1818L15.1302 12.1818C15.5507 12.1818 15.9001 12.2481 16.1785 12.3807C16.4588 12.5114 16.6681 12.6903 16.8063 12.9176C16.9465 13.1449 17.0166 13.4025 17.0166 13.6903C17.0166 13.9271 16.9711 14.1297 16.8802 14.2983C16.7893 14.465 16.6671 14.6004 16.5137 14.7045C16.3603 14.8087 16.1889 14.8835 15.9995 14.929V14.9858C16.206 14.9972 16.4039 15.0606 16.5933 15.1761C16.7846 15.2898 16.9408 15.4508 17.062 15.6591C17.1832 15.8674 17.2438 16.1193 17.2438 16.4148C17.2438 16.7159 17.1709 16.9867 17.0251 17.2273C16.8793 17.4659 16.6596 17.6544 16.366 17.7926C16.0724 17.9309 15.7031 18 15.258 18L12.9029 18ZM13.9569 17.1193L15.0904 17.1193C15.473 17.1193 15.7486 17.0464 15.9171 16.9006C16.0876 16.7528 16.1728 16.5634 16.1728 16.3324C16.1728 16.16 16.1302 16.0047 16.045 15.8665C15.9597 15.7263 15.8385 15.6165 15.6813 15.5369C15.5241 15.4555 15.3366 15.4148 15.1188 15.4148L13.9569 15.4148L13.9569 17.1193ZM13.9569 14.6562L14.9995 14.6562C15.1813 14.6562 15.3452 14.6231 15.491 14.5568C15.6368 14.4886 15.7514 14.393 15.8347 14.2699C15.92 14.1449 15.9626 13.9972 15.9626 13.8267C15.9626 13.6013 15.883 13.4157 15.7239 13.2699C15.5668 13.1241 15.3329 13.0511 15.0222 13.0511H13.9569L13.9569 14.6562ZM22.1809 14.1449H21.1184C21.088 13.9706 21.0322 13.8163 20.9507 13.6818C20.8693 13.5455 20.768 13.4299 20.6468 13.3352C20.5255 13.2405 20.3873 13.1695 20.232 13.1222C20.0786 13.0729 19.9129 13.0483 19.7348 13.0483C19.4185 13.0483 19.1382 13.1278 18.8939 13.2869C18.6496 13.4441 18.4583 13.6752 18.3201 13.9801C18.1818 14.2831 18.1127 14.6534 18.1127 15.0909C18.1127 15.536 18.1818 15.911 18.3201 16.2159C18.4602 16.5189 18.6515 16.7481 18.8939 16.9034C19.1382 17.0568 19.4176 17.1335 19.732 17.1335C19.9062 17.1335 20.0691 17.1108 20.2206 17.0653C20.374 17.018 20.5113 16.9489 20.6326 16.858C20.7557 16.767 20.8589 16.6553 20.9422 16.5227C21.0274 16.3902 21.0862 16.2386 21.1184 16.0682L22.1809 16.0739C22.1411 16.3504 22.0549 16.6098 21.9223 16.8523C21.7916 17.0947 21.6202 17.3087 21.4081 17.4943C21.196 17.678 20.9479 17.822 20.6638 17.9261C20.3797 18.0284 20.0644 18.0795 19.7178 18.0795C19.2064 18.0795 18.75 17.9612 18.3485 17.7244C17.947 17.4877 17.6307 17.1458 17.3996 16.6989C17.1685 16.2519 17.053 15.7159 17.053 15.0909C17.053 14.464 17.1695 13.928 17.4024 13.483C17.6354 13.036 17.9526 12.6941 18.3541 12.4574C18.7557 12.2206 19.2102 12.1023 19.7178 12.1023C20.0416 12.1023 20.3428 12.1477 20.6212 12.2386C20.8996 12.3295 21.1477 12.4631 21.3655 12.6392C21.5833 12.8134 21.7623 13.0275 21.9024 13.2812C22.0445 13.5331 22.1373 13.821 22.1809 14.1449Z",
    fill: "#272727"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80_2180)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 23.8536,
    y1: 7.35355,
    x2: 7.85355,
    y2: 23.3536,
    stroke: "#272727"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80_2180",
    x: 7.5,
    y: 7,
    width: 16.707,
    height: 17.7072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_2180"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_2180",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossOutToggle);
export default __webpack_public_path__ + "static/media/CrossOutToggle.dcefcf9a3524a3bdfd92462bb6a2198d.svg";
export { ForwardRef as ReactComponent };